import { motion } from 'framer-motion';

const TutorToby = ({ mood = 'neutral', size = 'medium', speaking = false }) => {
  const sizeClasses = {
    small: 'w-24 h-24',
    medium: 'w-40 h-40',
    large: 'w-64 h-64',
  };

  const getMouthPath = () => {
    switch (mood) {
      case 'happy': return 'M70 130 Q100 150 130 130';
      case 'excited': return 'M70 125 Q100 155 130 125';
      case 'thinking': return 'M80 130 L120 130';
      case 'encouraging': return 'M75 130 Q100 145 125 130';
      default: return 'M80 130 Q100 140 120 130';
    }
  };

  const getEyebrows = () => {
    switch (mood) {
      case 'happy': return 'M55 65 Q72 55 90 65 M110 65 Q128 55 145 65';
      case 'excited': return 'M55 60 Q72 50 90 60 M110 60 Q128 50 145 60';
      case 'thinking': return 'M55 70 Q72 65 90 70 M110 65 Q128 70 145 65';
      default: return 'M55 68 Q72 62 90 68 M110 68 Q128 62 145 68';
    }
  };

  return (
    <div className={`${sizeClasses[size]} mx-auto`}>
      <motion.svg 
        viewBox="0 0 200 200" 
        className="w-full h-full drop-shadow-lg"
        animate={speaking ? { scale: [1, 1.02, 1] } : {}}
        transition={{ duration: 0.3, repeat: speaking ? Infinity : 0 }}
      >
        {/* Background Circle */}
        <circle cx="100" cy="100" r="95" fill="#2E8B57" />
        <circle cx="100" cy="100" r="88" fill="#3CB371" />
        
        {/* Face */}
        <circle cx="100" cy="95" r="55" fill="#D4A574" />
        
        {/* Hair */}
        <ellipse cx="100" cy="55" rx="45" ry="22" fill="#4A3728" />
        <ellipse cx="100" cy="48" rx="40" ry="18" fill="#5D4632" />
        
        {/* Glasses */}
        <rect x="58" y="78" width="32" height="24" rx="4" fill="none" stroke="#2D3748" strokeWidth="3" />
        <rect x="110" y="78" width="32" height="24" rx="4" fill="none" stroke="#2D3748" strokeWidth="3" />
        <line x1="90" y1="90" x2="110" y2="90" stroke="#2D3748" strokeWidth="3" />
        <line x1="58" y1="90" x2="48" y2="88" stroke="#2D3748" strokeWidth="2" />
        <line x1="142" y1="90" x2="152" y2="88" stroke="#2D3748" strokeWidth="2" />
        
        {/* Eyes */}
        <motion.circle 
          cx="74" 
          cy="90" 
          r="6" 
          fill="#2D3748"
          animate={mood === 'thinking' ? { cy: [90, 88, 90] } : {}}
          transition={{ duration: 2, repeat: Infinity }}
        />
        <motion.circle 
          cx="126" 
          cy="90" 
          r="6" 
          fill="#2D3748"
          animate={mood === 'thinking' ? { cy: [90, 88, 90] } : {}}
          transition={{ duration: 2, repeat: Infinity }}
        />
        
        {/* Eye sparkle */}
        <circle cx="76" cy="88" r="2" fill="white" />
        <circle cx="128" cy="88" r="2" fill="white" />
        
        {/* Eyebrows */}
        <motion.path 
          d={getEyebrows().split(' M')[0]} 
          fill="none" 
          stroke="#4A3728" 
          strokeWidth="3"
        />
        <motion.path 
          d={'M' + getEyebrows().split(' M')[1]} 
          fill="none" 
          stroke="#4A3728" 
          strokeWidth="3"
        />
        
        {/* Nose */}
        <path d="M95 100 Q100 110 105 100" fill="none" stroke="#C4956A" strokeWidth="2" />
        
        {/* Mustache */}
        <path d="M72 118 Q100 128 128 118 Q115 125 100 125 Q85 125 72 118" fill="#4A3728" />
        
        {/* Mouth */}
        <motion.path 
          d={getMouthPath()} 
          fill="none" 
          stroke="#2D3748" 
          strokeWidth="3"
          strokeLinecap="round"
        />
        
        {/* Shirt collar */}
        <path d="M65 150 L100 165 L135 150" fill="#1A365D" />
        <circle cx="100" cy="160" r="4" fill="#FFE66D" />
        
        {/* Blush for happy */}
        {(mood === 'happy' || mood === 'excited') && (
          <>
            <ellipse cx="55" cy="105" rx="8" ry="5" fill="#E8A598" opacity="0.5" />
            <ellipse cx="145" cy="105" rx="8" ry="5" fill="#E8A598" opacity="0.5" />
          </>
        )}
      </motion.svg>
    </div>
  );
};

export default TutorToby;
